import React from 'react';
import { useLocation } from 'react-router';
import { ActionModal, MakeToast } from '../../../../../components';
import { EditFileProps } from '../../kb.props';
import { validateTextField } from '../../../../../services';
import { FileNameText } from '../../data/constants';
import { editFileName } from '../../services/kb';

function EditFile({
  open,
  dataToEdit,
  handleCancelClick,
  dispatcher,
  editError,
  SetEditError,
}: EditFileProps) {
  const { state } = useLocation();
  const { folderId } = state || {};

  const handleEditFile = () => {
    const err = validateTextField(dataToEdit.name, 'File Name');
    if (dataToEdit.name && dataToEdit.name.length > 220) {
      SetEditError('File name should not exceed 220 characters.');
      return;
    }
    if (err) {
      SetEditError(err);
      return;
    }
    const payload = {
      id: dataToEdit.id,
      name: dataToEdit.name,
    };
    editFileName(folderId, payload)
      .then((res) => {
        if (res.status === 200) {
          dispatcher({
            type: 'FILE_TO_EDIT',
            payload: { id: dataToEdit.id, name: dataToEdit.name },
          });
          dispatcher({ type: 'TOGGLE_EDIT_MODAL', payload: false });
          dispatcher({ type: 'DATA_UPDATED', payload: (prev: boolean) => !prev });
          SetEditError('');
          MakeToast('success', res?.data?.message);
        }
      })
      .catch(() => {
        MakeToast('error', 'Something went wrong');
      });
  };

  const handleFileNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    let err = validateTextField(value, 'File Name');
    if (value.length > 220) {
      err = 'File name should not exceed 220 characters.';
    }
    SetEditError(err || '');
    if (name === 'edit_file_name') {
      dispatcher({ type: 'FILE_TO_EDIT', payload: { ...dataToEdit, name: value } });
    }
  };

  return (
    <ActionModal
      className="w-[400px]"
      open={open}
      resetData={handleCancelClick}
      confirmButtonText="Save"
      saveData={handleEditFile}
    >
      <div className="flex flex-col p-2 w-full mb-2">
        <span className="text-[#344054] font-medium text-sm mb-1">
          {FileNameText}
          <span className="text-red-600">*</span>
        </span>
        <input
          placeholder="Enter File Name"
          className={`mt-1 text-sm py-[10px] ${
            editError ? 'focus:border-red-600 border-red-600' : 'border-[#E4E4E7]'
          } 
                    rounded-lg w-full`}
          onChange={handleFileNameChange}
          required
          name="edit_file_name"
          value={dataToEdit.name || ''}
        />
        {editError && <span className="text-red-600 text-xs">{editError}</span>}
      </div>
    </ActionModal>
  );
}

export default EditFile;
